import React from 'react';
import { Trans, useTranslation } from 'next-i18next';
import { useContextSelector } from 'use-context-selector';
import AccountSettingsSectionHeader from '@components/account-settings/account-settings-section-header/account-settings-section-header';
import Button from '@components/atoms/button/button';
import { ModalContext } from '@context/modal.context';
import { useAnalytics } from '@context/analytics/analytics.context';
import {
  accountSettingsDeleteAccountEventPayload,
  accountSettingsReadFaqsEventPayload,
} from '@tracking/account-settings/account-settings-tracking';
import DeleteAccountConfirmation from '@pages/my-account/delete-account/components/delete-account-confirmation';
import styles from './delete-account.module.scss';

const PRIVACY_PORTAL_URL =
  'https://api.dastra.eu/v1/client/customer-subject-form?id=406&key=n9tdbOdLDiWBC3FvcEnfbC1eL6QBV3FbqWDyJSAnbB';

const DeleteAccount: React.FC = () => {
  const { t } = useTranslation('account-settings');
  const { t: tCommon } = useTranslation('common');
  const openModal = useContextSelector(ModalContext, (v) => v.openModal);
  const { sendEvent } = useAnalytics();

  const handleDeleteClick = () => {
    sendEvent({ type: 'event', payload: accountSettingsDeleteAccountEventPayload });
    openModal(<DeleteAccountConfirmation showBackButton={false} />, {
      fullScreenOnMobile: false,
      styles: {
        content: {
          width: 'calc(100% - 40px)',
          maxWidth: '600px',
        },
      },
    });
  };

  return (
    <div className={styles.deleteAccount}>
      <AccountSettingsSectionHeader
        title={t('ACCOUNT_SETTINGS.DELETE_ACCOUNT.TITLE')}
        isEditable={false}
      />
      <p className={styles.deleteAccount__description}>
        <Trans
          ns="account-settings"
          i18nKey="ACCOUNT_SETTINGS.DELETE_ACCOUNT.SUB_TITLE"
          components={{
            faqLink: (
              <a
                href={tCommon('ACCOUNT_DELETION_FAQ_LINK')}
                target="_blank"
                rel="noreferrer"
                onClick={() => {
                  sendEvent({ type: 'event', payload: accountSettingsReadFaqsEventPayload });
                }}
                className={styles.deleteAccount__description__faqLink}
              >
                {'.'}
              </a>
            ),
          }}
        />
      </p>
      <Button
        size="medium"
        data-cy="delete-account-button"
        variant="destructive"
        onClick={handleDeleteClick}
      >
        {t('ACCOUNT_SETTINGS.DELETE_ACCOUNT.DELETE_BUTTON')}
      </Button>
      <p className={styles.deleteAccount__privacyNote}>
        <Trans
          ns="account-settings"
          i18nKey="ACCOUNT_SETTINGS.DELETE_ACCOUNT.PRIVACY_BANNER"
          components={{
            privacyPolicyLink: (
              <a
                href={tCommon('LEGAL.LINK.PRIVACY_POLICY')}
                target="_blank"
                rel="noreferrer"
                className={styles.deleteAccount__description__faqLink}
              >
                {'.'}
              </a>
            ),
            privacyPortalLink: (
              <a
                href={PRIVACY_PORTAL_URL}
                target="_blank"
                rel="noreferrer"
                className={styles.deleteAccount__description__faqLink}
              >
                {'.'}
              </a>
            ),
          }}
        />
      </p>
    </div>
  );
};

export default DeleteAccount;
